import React from 'react'
import { Box } from 'grommet'
import styled from 'styled-components'
import PickerWheelManual from './PickerWheelManual'
// import FlipSimuImage from '../../images/common/flipsimu.png'
// import Ezoic from "../Ezoic/stickyEzoic"
// import { EzoicId } from "../Ezoic/ids"
import FlipsimuPost from '../AffiliatePost/flipsimu'
import { device } from '../../theme/device'
import Adthrive from '../Adthrive'

const OuterContentBox = styled(Box)`
  width: 113rem;
  padding: 2rem 1.5rem 3rem;
  @media ${device.medium} {
    padding: 2rem 1.5rem 1rem;
  }
`
const ContentBox = styled(Box)`
  max-width: 73rem;
  @media (max-width: 767px) {
    max-width: 100%;
  }
`
// const SidebarBox = styled(Box)`
//   min-width: 31.4rem;
// `

// const StickyBox = styled(Box)`
//   position: -webkit-sticky;
//   position: sticky;
//   top: 5%;
//   background-color: black;
//   height: 50vh;
//   overflow: auto;
//   min-height: 600px;
//   min-width: 300px;
// `

const Container = styled(Box)`
  flex-direction: row;
  align-items: stretch;
  @media (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }
`

const Content = ({ content, tool = 'coin' }) => {
  return (
    <OuterContentBox>
      <Container
        flex={true}
        // direction={size === "medium" ? "column" : "row"}
        justify="between"
      >
        <ContentBox basis="1">
          <PickerWheelManual file={content} />
        </ContentBox>
        <Adthrive
          width={{ min: '31.4rem' }}
          id="pageSidebar"
          gap="1rem"
          margin={{ top: '1rem' }}
          flex={false}
        >
          {tool === 'coin' && (
            <FlipsimuPost
              tool="coin"
              url="https://flipsimu.com/"
              title="Flip a coin to make a decision?"
              alt="FlipSimu Coin Flip Simulator"
              altPost="Coin Flipper"
              cta="Try FlipSimu Coin Flipper->"
            />
          )}
          {tool === 'dice' && (
            <FlipsimuPost
              tool="dice"
              url="https://flipsimu.com/dice-roller/"
              title="Roll a die for your dice game"
              alt="FlipSimu Dice Roller"
              altPost="Dice Roller"
              cta="Try FlipSimu Dice Roller->"
            />
          )}
        </Adthrive>
        {/* <>
          {typeof window === 'undefined' ||
          process.env.GATSBY_BUILD_CONTEXT === 'development' ||
          isPremium ? (
            <SidebarBox
              id="pageSidebar"
              gap="1rem"
              margin={{ top: '1rem' }}
              flex={false}
            >
              <FlipsimuPost
                url="https://flipsimu.com"
                title="Flip a coin to make a decision?"
                alt="FlipSimu Coin Flip Simulator"
                altPost="Coin Flipper"
                cta="Try FlipSimu Coin Flipper->"
              />
            </SidebarBox>
          ) : (
            <div
              id="pageSidebar"
              dangerouslySetInnerHTML={{
                __html: '',
              }}
              //   suppressHydrationWarning
            />
          )}
        </> */}
      </Container>

      {/* <AdsBox adSlot={AdSlot.SidebarContent} adType="sidebar" /> */}
    </OuterContentBox>
  )
}

export default Content
